import { useMemo } from "react";
import { useCommonDataContext } from "@core/CommonDataContext";
import { IOption } from "@models";
import { Metric, compareMetrics } from "@core/models/Metric";

export function useMetricOptions(
    metricsOrder: Metric[] = []
): IOption<Metric, string>[] {
    const { metrics: metricsConfig } = useCommonDataContext();

    return useMemo(
        (): IOption<Metric, string>[] => {
            return (metricsConfig ?? [])
                .filter((i) => metricsOrder.includes(i.id as Metric))
                .map((i) => ({
                    id: i.id as Metric,
                    title: i.name ?? '',
                }))
                .sort((a, b) => compareMetrics(metricsOrder, a.id, b.id));
        },
        [metricsConfig, metricsOrder]
    );
}